import { http } from '@/common/utils/HttpServices';
import { AuthenticationParameters, CreationCompteParametres } from '@/modules/Auth/store/state';
import { Routes } from '@/api/Routes';

class LoginService {
    public async signIn(data: AuthenticationParameters): Promise<any> {
        return http.post(Routes.LoginRoutes.PostAuthentication(), data);
    }
    public async verifierLogin(data: AuthenticationParameters): Promise<any> {
        return http.post(Routes.LoginRoutes.VerifierLogin(), data);
    }
    public async registerMail(data: AuthenticationParameters): Promise<any> {
        if (data.mail != undefined) {
            return http.post(Routes.LoginRoutes.RegisterMail(data.mail), data);
        }
    }

    public async demanderCreationCompte(data: CreationCompteParametres): Promise<any> {
        return http.post(Routes.LoginRoutes.CreerCompte(), data);
    }
    public async demanderCreationCompteFournisseur(data: CreationCompteParametres): Promise<any> {
        return http.post(Routes.LoginRoutes.CreerCompteFournisseur(), data);
    }
}

export default new LoginService();
